import { doc, $ } from "./util.js";

export function initMenu() {
  const hdr = $("#hdr");
  const burger = $("#burger");
  const panel = $("#mpanel");

  if (hdr) {
    const onScroll = () => hdr.classList.toggle("scrolled", window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }
  if (!burger || !panel) return;

  const close = () => {
    if (panel.hidden) return;
    panel.hidden = true;
    burger.setAttribute("aria-expanded", "false");
    burger.setAttribute("aria-label", "Open menu");
    doc.body.style.overflow = "";
  };
  burger.addEventListener("click", () => {
    const open = panel.hidden;
    panel.hidden = !open;
    burger.setAttribute("aria-expanded", String(open));
    burger.setAttribute("aria-label", open ? "Close menu" : "Open menu");
    doc.body.style.overflow = open ? "hidden" : "";
    if (open) {
      const a = $("a", panel);
      if (a) a.focus();
    }
  });
  doc.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !panel.hidden) {
      close();
      burger.focus();
    }
  });
  panel.addEventListener("click", (e) => {
    if (e.target.closest("a")) close();
  });
  window.addEventListener("resize", () => {
    if (window.innerWidth > 1060) close();
  });
}
